import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  correctPassword: 'liftoff', 
  isAuthorized: false,
};
const slice = createSlice({
  name: 'stagingGateway',
  initialState: initialState,
  reducers: {
    authorize: (state, action) => ({
      ...state,
      isAuthorized: true,
    }),
  }
});

// Extract the action creators object and the reducer
const { actions, reducer } = slice;
// Extract and export each action creator by name
export const {
  authorize,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
